import React from 'react';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ScrollToTop from './ScrollToTop';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import AppRoutes from './routes';
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { HelmetProvider } from 'react-helmet-async'; // Add this import

const theme = createTheme({
  palette: {
    primary: { main: "#3f51b5" },
    secondary: { main: "#ff4081" },
    background: { default: "#ffffff" },
  },
  typography: {
    fontFamily: '"Roboto", "Arial", sans-serif',
    h1: { fontWeight: 700, fontSize: "2.5rem", color: "#3f51b5" },
    body1: { fontSize: "1rem", color: "#555" },
  },
});

const AppWrapper = () => {
  const { loading } = useAuth();
  if (loading) {
    return <h2>Loading...</h2>; 
  }
  return <AppRoutes />;
};

function App() {
  return (
    <HelmetProvider> {/* Add this wrapper */}
      <AuthProvider>
        <ThemeProvider theme={theme}>
          <Router>
            <ScrollToTop /> 
            <AppWrapper />
          </Router>
        </ThemeProvider>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;